module.exports = __webpack_public_path__ + "852bf73e1a6aa8ac43beb71b36c05809.fbx";